import { z } from 'zod';
import { makeStandardLineItemSchema } from '../freightOrder';

export const makeStandardCustomerChargesSchema = () => {
  return z.object({
    lineItems: z.array(makeStandardLineItemSchema()),
  });
};

const StandardCustomerChargesSchema = makeStandardCustomerChargesSchema();
export type StandardCustomerCharges = z.infer<
  typeof StandardCustomerChargesSchema
>;
